export enum UserRole {
    ROLE_USER_CREATER = "ROLE_USER_CREATER",
    ROLE_PARKINGLOT = "ROLE_PARKINGLOT",
    ROLE_VLE_MODIFIER = "ROLE_VLE_MODIFIER",
    ROLE_VJT = "ROLE_VJT"
}
